var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDealDurationSolid = function SvgDealDurationSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.75 3a.75.75 0 0 0-1.5 0v1.25H5A2.75 2.75 0 0 0 2.25 7v12A2.75 2.75 0 0 0 5 21.75h8.316a6 6 0 0 1 6.43-9.492v-1.181A.753.753 0 0 0 19.75 11V7A2.75 2.75 0 0 0 17 4.25h-1.25V3a.75.75 0 0 0-1.5 0v1.25h-6.5V3Zm8 2.75h-1.5V7a.75.75 0 0 0 1.5 0V5.75Zm-8 0h-1.5V7a.75.75 0 0 0 1.5 0V5.75ZM18.25 10a.75.75 0 0 1-.75.75h-13a.75.75 0 0 1 0-1.5h13a.75.75 0 0 1 .75.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 16.496a.75.75 0 0 0-1.5 0V18c0 .199.079.39.22.53l1 1a.75.75 0 1 0 1.06-1.06l-.78-.78v-1.194Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13.25a4.75 4.75 0 1 0 0 9.5 4.75 4.75 0 0 0 0-9.5ZM14.75 18a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Z",
    fill: "currentColor"
  })));
};
export default SvgDealDurationSolid;